<script setup lang="ts">
import type { NuxtPicture } from "#components";
import ContentImageActions from "./ContentImageActions/ContentImageActions.vue";

const props = withDefaults(
  defineProps<{
    provider?: string;
    src?: string;
    width?: number | string;
    height?: number | string;
    alt?: string;
    caption?: string;

    imageId?: string;

    sizes?: string;

    pictureAttrs?: PropType<typeof NuxtPicture> & Record<string, unknown>;
  }>(),
  { caption: undefined }
);

const { currentPalette } = useTheme();

const { isImageOnAnyUserBoard } = useBoards();
const { isSaveOpen } = usePostSave();
const { user } = useAuth();

const { data: isSaved } = useAsyncData(
  `image:${props.imageId}:is-saved`,
  async () =>
    props.imageId ? await isImageOnAnyUserBoard(props.imageId) : false,
  { watch: [isSaveOpen, user] }
);
</script>

<template>
  <figure class="content-image">
    <div class="content-image__wrapper overflow-hidden relative group/image">
      <button
        class="block w-full h-auto p-0 m-0 cursor-zoom-in"
        @click="$emit('zoom')"
        title="Powiększ"
      >
        <NuxtPicture
          v-bind="{ provider, src, width, height, alt, ...pictureAttrs }"
          :class="[currentPalette.bg]"
          :img-attrs="{
            role: 'presentation',
            class: [
              'block w-full h-auto',
              'transition duration-500',
              'transform scale-[1.01] hover:scale-110 group-hover/image:scale-110 active:scale-100 group-active/image:scale-100 group-focus-within/image:scale-110',
              currentPalette.bg,
            ],
            draggable: false,
          }"
          role="presentation"
          alt=""
          :sizes="sizes"
          quality="65"
          preload
        />
      </button>

      <ContentImageActions vertical="top" horizontal="start">
        <ContentImageActionsButton @click="$emit('share')" title="Udostępnij">
          <Icon name="ns:share-2" class="w-[1.125rem] h-[1.125rem]" />
        </ContentImageActionsButton>
      </ContentImageActions>

      <ContentImageActions vertical="top" horizontal="end">
        <ContentImageActionsButton
          @click="$emit('like')"
          title="Dodaj do tablicy"
        >
          <PostLike :model-value="isSaved || false" />
        </ContentImageActionsButton>
      </ContentImageActions>

      <ContentImageActions vertical="bottom" horizontal="end">
        <ContentImageActionsButton @click="$emit('zoom')" title="Powiększ">
          <Icon name="ns:maximize-2" class="w-[1.125rem] h-[1.125rem]" />
        </ContentImageActionsButton>
      </ContentImageActions>
    </div>

    <figcaption
      v-if="caption"
      class="content-image__caption text-[0.5rem] leading-4 text-grey px-5 lg:px-0"
    >
      {{ caption }}
    </figcaption>
  </figure>
</template>
